require('./stylesheet/index.scss');

angular.module('pages.lookup', [])
	.config(config);

config.$inject = ['$stateProvider'];
function config($stateProvider) {
	$stateProvider
		.state('pages.lookup', {
			url: 'lookup/',
			template: require('./templates/index.html'),
			controller: require('./controllers/lookup'),
			data: {},
			params: {
                paymentId: null,
				serviceId: null,
                name: null,
                category: null,
                furl: null
			},
			pageTrack: '/lookup'
		})
}

module.exports = 'pages.lookup';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/lookup/index.js
 ** module id = 269
 ** module chunks = 1
 **/